import NoSsr from '@app/domains/common/components/NoSsr';
import SeoHelmet from '@app/domains/common/components/SeoHelmet';
import { HOME_PAGE_META_DATA } from '@app/domains/home/constants/seo';
import HomeFeaturedCards from '@app/domains/home/containers/HomeFeaturedCards';
import HomeNovelsSubscriptions from '@app/domains/home/containers/HomeNovelsSubscriptions';
import HomePopularGenreNovelsFetcher from '@app/domains/home/containers/HomePopularGenreNovelsFetcher';
import HomePopularNovels from '@app/domains/home/containers/HomePopularNovels';
import HomeRecentNovels from '@app/domains/home/containers/HomeRecentNovels';
import HomeRecentlyUpdatedChapters from '@app/domains/home/containers/HomeRecentlyUpdatedChapters';
import HomeRecommendedNovels from '@app/domains/home/containers/HomeRecommendedNovels';
import HomeRotationNovels from '@app/domains/home/containers/HomeRotationNovels';
import HomeSiteAnnouncements from '@app/domains/home/containers/HomeSiteAnnouncements';
import HomeSneakPeekNovelsN from '@app/domains/home/containers/HomeSneakPeekNovelsN';
import HomeTrendingNovels from '@app/domains/home/containers/HomeTrendingNovels';
import { HOME_LAYOUT_STYLE } from '@app/domains/home/styles';
import { useAuth } from '@app/libs/auth';
import clsx from 'clsx';

function HomePage() {
    const { user } = useAuth();

    return (
        <div className="overflow-hidden">
            <SeoHelmet {...HOME_PAGE_META_DATA} />
            <div className={clsx(HOME_LAYOUT_STYLE, 'pt-16 pb-40 sm:pt-36 sm:pb-80')}>
                <div className="flex w-full flex-col lg:flex-row lg:space-x-40">
                    <div className="lg:w-[61.66%]">
                        <HomeFeaturedCards />
                    </div>
                    <div className="lg:w-[35%] lg:pt-8">
                        <HomeSiteAnnouncements />
                    </div>
                </div>
                <div className="flex w-full flex-col md:flex-row">
                    <div
                        className={clsx('md:w-[61.66%] overflow-hidden', {
                            'md:!w-full': !user,
                        })}
                    >
                        <HomePopularNovels />
                        <HomeRecentNovels />
                    </div>
                    <NoSsr>
                        {user && (
                            <div className="md:w-[35%] md:ml-40 overflow-hidden">
                                <HomeTrendingNovels />
                            </div>
                        )}
                    </NoSsr>
                </div>
                <NoSsr>{user && <HomeNovelsSubscriptions />}</NoSsr>
                <HomeRecommendedNovels />
                <HomeRotationNovels />
                <HomePopularGenreNovelsFetcher />
                <HomeSneakPeekNovelsN />
                <div className="mt-32 md:mt-36">
                    <HomeRecentlyUpdatedChapters />
                </div>
            </div>
        </div>
    );
}

export default HomePage;
